import {styled} from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Button from "@memaro/components/Button.tsx";
import {useCallback, useEffect, useState} from "react";
import {useRouter} from "../hooks/useRouter";
import Menu from "../components/Menu";
import apiClient from "../lib/api.ts";
import {ListProfilesEntry} from "@memaro/api";
import ProfileListItem from "../components/ProfileListItem.tsx";
import Skeleton from "@mui/material/Skeleton";
import {useFeedback} from "@memaro/feedback";
import {authenticated} from "../hoc/auth.tsx";

const StyledStack = styled(Stack)({
    width: 'fit-content',
    margin: '0 auto'
});

const HomePage = authenticated(() => {
    const {gotoMemorial} = useRouter();
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingNew, setLoadingNew] = useState<boolean>(false)
    const [profiles, setProfiles] = useState<ListProfilesEntry[]>([])
    const {error} = useFeedback()

    useEffect(() => {
        setLoading(true)
        apiClient.listProfiles()
            .then(output => setProfiles(output.profiles))
            .catch(() => error?.("Er is een fout opgetreden bij het ophalen van de herinneringspagina's. Probeer het later opnieuw."))
            .finally(() => setLoading(false))
    }, [error])

    const handleNew = useCallback(() => {
        setLoadingNew(true)
        apiClient.createProfile()
            .then(profile => {
                gotoMemorial(profile.id)
            })
            .catch(() => error?.("Er is een fout opgetreden bij het creeren van een nieuwe herinneringspagina. Probeer het later opnieuw."))
            .finally(() => setLoadingNew(false))
    }, [error, gotoMemorial])

    return (
        <>
            <Menu/>
            <StyledStack>
                <h1>Herinnerings&shy;pagina's</h1>
                {!loading ? profiles.map(profile => (
                    <ProfileListItem key={profile.id} {...profile} />
                )) : (
                    <>
                        <Skeleton height={80} />
                        <Skeleton height={80} />
                        <Skeleton height={80} />
                    </>
                )}
                <Button onClick={handleNew} loading={loadingNew}>Nieuwe herinneringspagina aanmaken</Button>
            </StyledStack>
        </>
    )
})

export default HomePage
